import { ELEMENT_PARAGRAPH } from '@doltech/utils/lib/constants';
import { ParagraphToggle, ParagraphToggleNode, PARAGRAPH_TOGGLE } from './types';

export const createParagraphToggle = ({
  label = '',
  text = '',
  toggle = true,
  present = '',
  placeholder = '',
  parentNodeType = '',
  includeVoids,
  children = [
    {
      type: ELEMENT_PARAGRAPH,
      children: [
        {
          text,
        },
      ],
    },
  ],
}: ParagraphToggle & { text?: string }): ParagraphToggleNode => ({
  type: PARAGRAPH_TOGGLE,
  toggle,
  visible: true,
  label,
  present,
  placeholder,
  parentNodeType,
  children,
  includeVoids,
});
